module.exports = __webpack_public_path__ + "static/media/privacypolicy.58a827d5.htm";